/**
 * The `detail` of a backend sidecar refusal, or null.
 *
 * Every refusal the sidecar writes is `{ error, detail }` JSON, and its `detail` is written for the
 * operator who will read it: `ARTIFACT_DIR (/home/container/artifacts) has no schema/ subdirectory;
 * copy docs/contract/schema there` names the directory on that machine and what belongs in it, which
 * no message composed in the browser can. So a page that reports a failed read shows that sentence
 * when there is one, and its own wording only when there is not — a proxy's HTML error page, an empty
 * body, a body that is not the sidecar's. Capped, because it is printed in a card.
 */
export async function sidecarDetail(response: Response): Promise<string | null> {
  let body: unknown;
  try {
    body = await response.json();
  } catch {
    return null;
  }
  if (typeof body !== 'object' || body === null) return null;
  const detail = (body as { detail?: unknown }).detail;
  if (typeof detail !== 'string') return null;
  const text = detail.trim();
  if (text === '') return null;
  return text.length > MAX_DETAIL ? `${text.slice(0, MAX_DETAIL - 1)}…` : text;
}

const MAX_DETAIL = 400;
